import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import { TwoFactorService } from '../../../services/two-factor.service';

/**
 * Forced enrolment, reached only from the login form.
 *
 * The user's password was accepted but their organisation requires a second
 * factor they do not have yet, so `/token` refused the session and handed out
 * a short-lived enrolment token instead. Without that token there is nothing
 * to do here, which is why the page sends anyone else back to the login form:
 * the route is not a way to set up 2FA, it is the continuation of a sign-in
 * that is already half done.
 */
@Component({
  selector: 'app-two-factor-setup',
  templateUrl: './two-factor-setup.component.html',
  styleUrl: './two-factor-setup.component.scss',
  standalone: false,
})
export class TwoFactorSetupComponent implements OnInit {
  constructor(
    private twoFactor: TwoFactorService,
    private router: Router,
    private toastr: NbToastrService,
  ) {}

  /** Which sentence explains the force: the platform rule for a super_admin,
   *  or the tenant switch for everyone else. Telling a super_admin their
   *  organisation demands it -- right after they switched the organisation
   *  off -- is how this became a support question. */
  get introKey(): string {
    return this.twoFactor.enrollmentReason === 'platform'
      ? 'pages.twofa.forcedIntroPlatform'
      : 'pages.twofa.forcedIntro';
  }

  ngOnInit(): void {
    if (!this.twoFactor.hasForcedEnrollment) {
      this.router.navigateByUrl('/auth/login');
    }
  }

  onCompleted(): void {
    // There is still no session: the enrolment token was never one. Signing in
    // again — now with the code — is the point.
    this.toastr.success(
      'Two-factor authentication is set up. Please sign in again.',
      'Two-factor',
    );
    this.router.navigateByUrl('/auth/login');
  }
}
